import React from 'react';
import { cn } from '@/lib/utils';

interface RadioButtonProps {
  checked: boolean;
  className?: string;
  disabled?: boolean;
  label?: string | React.ReactNode;
  labelClassName?: string;
  iconClassName?: string;
  onChange?: (checked: boolean) => void;
}

/**
 * 单选框组件
 */
export const RadioButton: React.FC<RadioButtonProps> = ({
  checked,
  onChange,
  className,
  disabled = false,
  label,
  labelClassName,
  iconClassName,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!disabled) {
      onChange?.(!checked);
    }
  };

  const radioButton = (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className={cn(
        'w-[20px] h-[20px] rounded-full flex items-center justify-center transition-color duration-200 border border-black',
        checked
          ? 'bg-black' // 勾选状态：黑色背景
          : 'bg-white', // 未勾选状态：白色背景
        disabled && 'opacity-50 cursor-not-allowed',
        className,
      )}
      aria-checked={checked}
      aria-disabled={disabled}
    >
      {checked && (
        <svg
          width="12"
          height="9"
          viewBox="0 0 12 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={cn('text-white', iconClassName)}
        >
          <path
            d="M1 4.5L4 7.5L11 1"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );

  if (!label) {
    return radioButton;
  }

  return (
    <div
      className="flex items-center cursor-pointer select-none"
      onClick={handleClick}
      style={{ opacity: disabled ? 0.5 : 1 }}
    >
      {radioButton}
      <span
        className={cn(
          'text-base ml-2',
          disabled && 'cursor-not-allowed',
          labelClassName
        )}
      >
        {label}
      </span>
    </div>
  );
};
